<div class="container d-flex flex-column align-items-center justify-content-center vh-100 bg-white">
  <img src="/assets/images/not-found.png" style="width: 900px;" alt="404 Image" class="img-fluid mb-3">
  <!-- <h1>404</h1>
  <p class="mt-4">Oops<br>Page not found</p>-->
  <a href="/" class="btn btn-primary mt-2" routerLink="/suzuki/overview">Home page</a> 
</div>
